import React, { FC } from 'react';
// mui components
import { Grid, Typography } from '@mui/material';
// components
import UserTag from './user-tag';
// api
import { IProjectProfiles } from 'redux-store/api/projects';
// styles
import { styles } from './styles';
import { IActivityFeedAudience, PostVisibilityEnum } from 'redux-store/api/activity-feed';
import { TConvertedAudience } from '../../../types';

interface ISpecificUsersListProps {
  profiles: IProjectProfiles[];
  customUsers: TConvertedAudience['customUsers'];
  onSetActiveAudience: React.Dispatch<React.SetStateAction<TConvertedAudience>>;
}

const SpecificUsersList: FC<ISpecificUsersListProps> = ({
  profiles,
  customUsers,
  onSetActiveAudience,
}) => {
  const onCustomUserToggle = (profile: IProjectProfiles, isSelected: boolean) => {
    const { id, role, avatar, lastName, firstName } = profile;

    const activityFeedAudienceProfile: IActivityFeedAudience = {
      profileId: id,
      roleName: role,
      avatar,
      firstName,
      lastName,
    };

    const customUsersList = isSelected
      ? customUsers.filter((p) => p.profileId !== activityFeedAudienceProfile.profileId)
      : [...customUsers, activityFeedAudienceProfile];

    onSetActiveAudience({
      postVisibility: PostVisibilityEnum.SPECIFIC_MEMBERS,
      byRole: [],
      customGroups: [],
      customUsers: customUsersList,
    });
  };

  return (
    <Grid sx={styles.container}>
      <Typography sx={styles.title}>or select specific users</Typography>
      <Grid sx={styles.usersListContainer}>
        {profiles.map((profile) => {
          const isSelected = customUsers.some((item) => item.profileId === profile.id);

          return (
            <UserTag
              profile={profile}
              isSelected={isSelected}
              onCustomUserToggle={() => onCustomUserToggle(profile, isSelected)}
              key={profile.id}
            />
          );
        })}
      </Grid>
    </Grid>
  );
};

export default SpecificUsersList;
